import { privateRequest, type ApiResponse } from "../axios";

export interface CustomField {
  Id: number;
  CustomType: string;
  Name: string;
  FieldType: string;
  Placeholder: string;
  IsMandatory: boolean;
  IsRangeBound: boolean;
  StartRange: number;
  EndRange: number;
  ModifiedBy: string;
  ModifiedDate: string;
  KYCPoints: number;
  Options?: OptionFields[];
  UpdateCustomFieldOptions?: OptionFields[];
  PermanentName?: string
}

export interface OptionFields {
  Id: number;
  Value: string;
  OptionId?: number;
  OptionValue?: string;
}

const ENDPOINTS = {
  CUSTOM_FIELD: "api/CustomFields",
};

const getCustomFields = async (): Promise<ApiResponse<CustomField[]>> => {
  const response = await privateRequest.get<ApiResponse<CustomField[]>>(ENDPOINTS.CUSTOM_FIELD);
  return response.data;
};

const deleteCustomField = async (data: any): Promise<ApiResponse<CustomField>> => {
  const response = await privateRequest.delete<ApiResponse<CustomField>>(`${ENDPOINTS.CUSTOM_FIELD}/${data.Id}?customType=${data.CustomType}`);
  return response.data;
};

const updateCustomField = async (data: CustomField): Promise<ApiResponse<CustomField>> => {
  const response = await privateRequest.put<ApiResponse<CustomField>>(ENDPOINTS.CUSTOM_FIELD, data);
  return response.data;
};

const addCustomField = async (data: CustomField): Promise<ApiResponse<CustomField>> => {
  const response = await privateRequest.post<ApiResponse<CustomField>>(ENDPOINTS.CUSTOM_FIELD, data);
  return response.data;
};

const CustomFieldService = {
  getCustomFields,
  deleteCustomField,
  updateCustomField,
  addCustomField,
};

export default CustomFieldService;
